/**
 * Editing a mission from its detail page (PR6 UX). The edit dialog lives on the missions list
 * (pages/Missions.js); the detail navigates there with router state naming the mission and the page to
 * return to. Once the dialog closes — saved or not — the list replaces itself with that detail, so the
 * detail reloads with the saved data and neither a reload nor the browser's back button reopens the
 * dialog. Opening the dialog from the list itself carries no return target and stays on the list.
 */

export const missionDetailPath = (missionId) => `/missions/${encodeURIComponent(missionId)}`;

/** Router state for `navigate('/missions', { state })` from the mission detail. */
export const editFromDetailState = (missionId) => ({
  editMissionId: missionId,
  returnTo: missionDetailPath(missionId),
});

/**
 * The page to return to once the dialog opened from `state` closes, or null (stay on the list). Only the
 * edited mission's own detail is accepted — the state is never taken as an arbitrary redirect target.
 */
export const editReturnPath = (state) => {
  const missionId = state?.editMissionId;
  if (!missionId || typeof state.returnTo !== 'string') return null;
  return state.returnTo === missionDetailPath(missionId) ? state.returnTo : null;
};
